import { DalyTimeSlot } from "../daly-time-slot.entity/daly-time-slot";

export class TimeBoarding {
    id: string;
    title: string;
    timeSlots: Array<DalyTimeSlot>

    constructor(other?: Partial<TimeBoarding>) {
        this.id = other?.id || '';
        this.title = other?.title || '';
        this.timeSlots = other?.timeSlots || [];
    }

    static fromResponse(res: any): TimeBoarding {
        return new TimeBoarding({
            id: res.id,
            title: res.title,
            timeSlots: Array.from(res.timeSlots || [], e => DalyTimeSlot.fromResponse(e))
        })
    }
}